<script lang="ts">
	import { env } from "$lib/env.client";
	import { page } from "$app/stores";
	import type { ClientUser } from "../../../models/ClientTypes";
	import * as Sentry from "@sentry/sveltekit";
	import LogRocket from "logrocket";
	import { onMount } from "svelte";

	export let user: ClientUser;

	let userToRecordInLogRocket: ClientUser;
	let logSession: boolean;
	let id: string;
	let traits: { logged_in: boolean; email?: string; name?: string };

	onMount(() => {
		userToRecordInLogRocket = user || $page.data.userToRecordInLogRocket;

		// TODO: Uncomment the line below to support recording visitors by specific path.
		// logSession = userToRecordInLogRocket?.caps.is_logrocket_enabled || shouldRecordUrl($page.url);
		logSession = userToRecordInLogRocket?.caps.is_logrocket_enabled as boolean;

		if (!logSession) {
			return;
		}

		if (userToRecordInLogRocket) {
			// There is a TypeScript error for the "id" because it's not part of the "User" model ("../../models/User").
			// TODO: We should create a client-side "User" model (without some DB fields, like ["_id", perks", ...]) and use that instead.
			id = user.id;
			traits = {
				email: user.email,
				name: user.name,
				logged_in: true
				// features: ','.join(user.features)
			};
		} else {
			// TODO: Add potentialId here to support recording of visitors
			id = "[potential_id]";
			traits = { logged_in: false };
		}

		LogRocket.init(env.PUBLIC_LOGROCKET_PROJECT!, { mergeIframes: true });
		LogRocket.identify(id, traits);

		LogRocket.getSessionURL((sessionURL) => {
			Sentry.getCurrentScope().setExtra("sessionURL", sessionURL);
		});
	});
</script>
